import {Component, Input, OnInit} from '@angular/core';

function toDate(value: string | Date): Date {
  return value instanceof Date ? value : new Date(value);
}

@Component({
  selector: 'app-time-duration',
  templateUrl: './time-duration.component.html',
  styleUrls: ['./time-duration.component.css']
})
export class TimeDurationComponent implements OnInit {

  @Input() start!: string | Date;
  @Input() finish!: string | Date;

  @Input() showMs = true;

  constructor() {
  }

  ngOnInit(): void {
  }

  format(): string {
    const startDate = toDate(this.start);
    const finishDate = toDate(this.finish);
    return `с ${startDate.toLocaleString()} по ${finishDate.toLocaleString()}`;
  }

  humanityFormat(): string {
    const startDate = toDate(this.start);
    const finishDate = toDate(this.finish);
    const diff = finishDate.getTime() - startDate.getTime();

    const milliseconds = Math.floor(diff % 1000);
    const seconds = Math.floor((diff / 1000) % 60);
    const minutes = Math.floor((diff / (1000 * 60)) % 60);
    const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
    const days = Math.floor(diff / (1000 * 60 * 60 * 24));

    let result = '';

    if (days) {
      result += `${days} дн. `;
    }
    if (hours) {
      result += `${hours} ч. `;
    }
    if (minutes) {
      result += `${minutes} мин. `;
    }
    if (seconds || (!this.showMs && !result)) {
      result += `${seconds} сек. `;
    }
    if (this.showMs && (milliseconds || !result)) {
      result += `${milliseconds} мс. `;
    }

    return result;
  }

}
